var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1438_53386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7785 14.6015L14.3981 14.6015C13.7909 15.547 12.9815 16.3472 12.0302 16.9458H16.7785V18.703L20.3332 15.7739L16.7785 12.8442V14.6015Z",
    fill: "#637DAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03399 16.9436C11.5728 16.9194 14.4348 14.0451 14.4348 10.5005C14.4348 7.13873 11.86 4.38111 8.57544 4.08471V2.29736L5.05981 5.22705L8.57544 8.15615V6.45814C10.5579 6.74553 12.0911 8.43975 12.0911 10.5005C12.0911 12.7619 10.2509 14.6021 7.9895 14.6021H0.333252V16.9458H8.03665C8.03548 16.9451 8.03513 16.9443 8.03399 16.9436Z",
    fill: "#637DAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12814 13.4303C4.36517 12.685 3.88794 11.6488 3.88794 10.5006C3.88794 9.13881 4.56243 7.9383 5.58731 7.19193L3.74603 5.65771C2.39899 6.83904 1.54419 8.56826 1.54419 10.5006C1.54419 11.5594 1.81606 12.5491 2.26845 13.4303H5.12814Z",
    fill: "#637DAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1438_53386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333252 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/devops.65592f2913be7e37e4856ec39ca0e0ca.svg";
export { ForwardRef as ReactComponent };